import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './assets/css/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeAnalytics } from './utils/analytics';
// Import ConsentProvider
import { ConsentProvider } from './consent-manager';

const routerConfig = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConsentProvider
      siteName="samyama"
      backendBaseUrl={process.env.REACT_APP_BACK_BASE_URL}
      debug={false} // Enable detailed debug logging
    >
      <BrowserRouter {...routerConfig}>
        <App />
      </BrowserRouter>
    </ConsentProvider>
  </React.StrictMode>
);

// Initialize analytics when Usercentrics consent is available
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, waiting for Usercentrics events');
  
  // Initialize analytics on consent
  document.addEventListener('ucEvent', function(event) {
    if (event.detail.event === 'consent_status') {
      console.log('Initializing analytics after consent event');
      initializeAnalytics();
    }
  });
  
  // Also try to initialize on page load in case consent was already given
  setTimeout(() => {
    if (window.UC_UI?.isInitialized()) {
      console.log('Usercentrics already initialized, initializing analytics');
      initializeAnalytics();
    }
  }, 1000);
});

reportWebVitals();